import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CheckService {

    constructor(
        private http: HttpClient
    ) { }

    getEnqiries(): Observable<any> {
        const url = `${environment.api}/check`;
        return this.http.get<Observable<any>>(url);
    }

    check(body): Observable<any> {
        const url = `${environment.api}/check`;
        return this.http.post<Observable<any>>(url, body);
    }

    download(): Observable<any> {
        const url = `${environment.api}/check/download`;
        return this.http.get<Observable<any>>(url);
    }

    resendEmail(id): Observable<any> {
        const url = `${environment.api}/check/${id}/resend_failed_email`;
        return this.http.post<Observable<any>>(url, {});
    }
}